import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { tID } from '../../utils/utils'

export interface ClipboardIconProps {
  size?: number | string
  color?: string
}

export const ClipboardIcon: FunctionComponent<ClipboardIconProps> = ({ size = 24, color, ...props }) => {
  const { colors } = useTheme()
  const strokeColor = color || colors.iconAccent

  return (
    <Svg width={size} height={size} viewBox='0 0 16 16' fill='none' testID={tID('ClipboardIcon')} {...props}>
      <Path
        d='M3.60039 13.5992C3.27039 13.5992 2.98789 13.4817 2.75289 13.2467C2.51789 13.0117 2.40039 12.7292 2.40039 12.3992V3.59922C2.40039 3.26922 2.51789 2.98672 2.75289 2.75172C2.98789 2.51672 3.27039 2.39922 3.60039 2.39922H6.45039C6.53928 2.05477 6.72539 1.76866 7.00872 1.54089C7.29206 1.31311 7.62261 1.19922 8.00039 1.19922C8.37817 1.19922 8.70872 1.31311 8.99206 1.54089C9.27539 1.76866 9.4615 2.05477 9.55039 2.39922H12.4004C12.7304 2.39922 13.0129 2.51672 13.2479 2.75172C13.4829 2.98672 13.6004 3.26922 13.6004 3.59922V12.3992C13.6004 12.7292 13.4829 13.0117 13.2479 13.2467C13.0129 13.4817 12.7304 13.5992 12.4004 13.5992H3.60039ZM3.60039 12.3992H12.4004V3.59922H11.2004V4.99922C11.2004 5.16922 11.1429 5.31172 11.0279 5.42672C10.9129 5.54172 10.7704 5.59922 10.6004 5.59922H5.40039C5.23039 5.59922 5.08789 5.54172 4.97289 5.42672C4.85789 5.31172 4.80039 5.16922 4.80039 4.99922V3.59922H3.60039V12.3992ZM7.99689 3.59922C8.16589 3.59922 8.30872 3.54205 8.42539 3.42772C8.54206 3.31339 8.60039 3.17172 8.60039 3.00272C8.60039 2.83372 8.54322 2.69089 8.42889 2.57422C8.31456 2.45755 8.17289 2.39922 8.00389 2.39922C7.83489 2.39922 7.69206 2.45639 7.57539 2.57072C7.45872 2.68505 7.40039 2.82672 7.40039 2.99572C7.40039 3.16472 7.45756 3.30755 7.57189 3.42422C7.68622 3.54089 7.82789 3.59922 7.99689 3.59922Z'
        fill={strokeColor}
      />
    </Svg>
  )
}
